import { useTranslation } from "react-i18next";

import { Link, Typography } from "@aviary";
import { AuthButtons } from "@emerson/components/AuthButtons/AuthButtons";
import { emersonRoutes } from "@emerson/data/emersonRoutes";
import type { WordpressSpecialType } from "@emerson/data/queries/WordpressSpecialsQuery/WordpressSpecialsQuery.query";
import { l } from "@emerson/locales/i18n";
import { useSharedGlobalConfig } from "@shared/hooks/useSharedGlobalConfig/useSharedGlobalConfig";

import { Brands } from "./Brands/Brands";
import { Education } from "./Education/Education";
import { Quality } from "./Quality/Quality";
import { Shop } from "./Shop/Shop";

import * as styles from "./Sidebar.styles";

interface Props {
  onClose: () => void;
  specialsData: { specials: WordpressSpecialType[]; showSpecials: boolean };
}

const Sidebar = ({ onClose, specialsData: { specials, showSpecials } }: Props) => {
  const { t } = useTranslation();
  const { isUnauthenticated } = useSharedGlobalConfig();
  const renderAuthButtons = () => isUnauthenticated && <AuthButtons />;

  const renderOrderRoute = () =>
    !isUnauthenticated && (
      <li>
        <Link
          isColor="system"
          to={emersonRoutes.orders.orderHistory}
          isUnderLined={false}
          isHoverUnderLined={false}
          onClick={onClose}
        >
          <Typography type="h5">{t(l.header.Orders.RecentOrders)}</Typography>
        </Link>
      </li>
    );

  const containerStyles = [styles.sidebarContent, !isUnauthenticated && styles.contentPadding];

  return (
    <div css={styles.sidebarScrollContainer}>
      <ul css={containerStyles}>
        <li>{renderAuthButtons()}</li>
        <li>
          <Shop onClose={onClose} specialsData={{ specials, showSpecials }} />
        </li>
        <li>
          <Brands onClose={onClose} />
        </li>
        <li>
          <Quality onClose={onClose} />
        </li>
        <li>
          <Education />
        </li>
        {renderOrderRoute()}
      </ul>
    </div>
  );
};

export { Sidebar };
